import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import { toIdentifierMask } from '../../services/mask';

type CompanyModel = {
  id: number;
  type: 1 | 2;
  identifier: string;
  name: string;
  alias?: string;
};

export default function CompaniesIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [companies, setCompanies] = useState([] as CompanyModel[]);

  const {
    user: { organization },
  } = useAuth();

  async function getCompanies() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/companies`
      );
      setCompanies(response.data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getCompanies();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Empresas' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>CPF/CNPJ</th>
            <th scope='col'>Nome</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((i) => {
            return (
              <tr key={i.id}>
                <th scope='row'>{i.id}</th>
                <td>
                  <Link to={`${i.id}/edit`}>
                    {toIdentifierMask(i.identifier, i.type)}
                  </Link>
                </td>
                <td>
                  {i.name}
                  {i.type === 1 ? (
                    <div className='text-muted small'>{i.alias}</div>
                  ) : (
                    ''
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
